import React from "react";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import PermissionComponentCheck from "../PermissionComponents/PermissionComponentCheck";

export const NavDropdownLink = props => {
  return (
    <PermissionComponentCheck
    requiredPermission={props.requiredPermission}
    denyAction="hide"
  >
    <Link id="dropdownLink" to={props.to}>
      <NavDropdown.Item as="button">{props.text}</NavDropdown.Item>
    </Link>
    </PermissionComponentCheck>
  );
};
